// extracted by mini-css-extract-plugin
export default {"checkbox_description":"CheckBox_checkbox_description__g1qtU","checkbox_row":"CheckBox_checkbox_row__SBnYg"};